module.exports = __webpack_public_path__ + "static/media/about.6d9648cb.jpg";